export const API_V1_URI = "/api/v1";
export const SYSTEM_CONFIG_API = API_V1_URI+ "/client/system_configs";
export const SYSTEM_CONFIG_CAPTCHA_API = SYSTEM_CONFIG_API+ "/captcha";
export const ACCOUNT_API = API_V1_URI+ "/accounts";

export const ACCOUNT_API_REFRESH_TOKEN = ACCOUNT_API + "/refresh-token";

export const ACCOUNT_API_SIGN_IN = ACCOUNT_API + "/login";
export const ACCOUNT_API_SIGN_IN_BY_QR = ACCOUNT_API + "/login_by_qr";
export const ACCOUNT_API_PROFILE = ACCOUNT_API + "/profile";
export const ACCOUNT_API_UPDATE_PASSWORD = ACCOUNT_API + "/update-password";
export const ACCOUNT_API_FORGOT_PASSWORD = ACCOUNT_API + "/forgot-password";
export const ACCOUNT_API_RESET_PASSWORD = ACCOUNT_API + "/reset-password";

export const CLIENT_API_V1_URI = API_V1_URI +"/client";


export const CLIENT_CUSTOMER_API = CLIENT_API_V1_URI + "/customers";

export const CLIENT_CUSTOMER_SENT_MAIL_TEMP_PASSWORD_API = CLIENT_CUSTOMER_API + "/sent_mail_temp_password";

export const CLIENT_CUSTOMER_ADDRESS_API = CLIENT_API_V1_URI + "/customer_addresses";

export const CLIENT_ORDER_API = CLIENT_API_V1_URI + "/orders";

export const ADDRESS_API = API_V1_URI + "/addresses";
export const ADDRESS_COUNTRIES_API = ADDRESS_API + "/countries";


